import React from "react";
import LatestNews from "./LatestNews";
import Events from "./Events";

const NewsEvents = () => {
  return (
    <>
      <div className="new-focus-area">
        <div className="container">
          <div className="row wow zoomIn">
            <LatestNews />
            <Events />
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsEvents;
